import React, { useEffect, useState } from 'react';
import Footer from '../containers/footer';
import Header from '../containers/header';
import Loading from '../components/loading/loading.js';
import { getCategories, deleteCategory } from '../services/categories.js';
import { Box, Chip, IconButton, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import CategoriesCardList from '../components/CategoriesCardList';
import DeleteConfirmModal from '../components/modals/DeleteConfirmModal';
import EditCategoryModal from '../components/modals/EditCategoryModal';
import NewCategoryModal from '../components/modals/NewCategoryModal';
import { useAlert } from '../context';
import { AlertSuccess } from '../components/Alerts';
import { isAdmin } from '../helpers/helpers_general.js';

const Home = () => {
  const initialState = {
    categoryId: 1,
    loading: true,
    page: 1,
    end: false,
    categories: [],
    categoryIdSelected: 0,
    categorySlugSelected: '',
    showEditModal: false,
    categorySelected: null,
    showCategoryModal: false,
  };

  const [states, setStates] = useState(initialState);
  const [search, setSearch] = useState('');
  const {
    setShowError,
    setShowSuccess,
    setTextSuccessAlert,
    setTextErrorAlert,
    textSuccessAlert,
  } = useAlert();

  useEffect(() => {
    getCategories().then(response =>
      setStates(prevState => ({
        ...prevState,
        categories: response.data,
        loading: false,
      }))
    );
  }, []);

  const handleSearch = () => {
    if (search.length > 0) window.location.href = '/search/' + search;
  };

  const deleteCard = () => {
    deleteCategory(states.categoryIdSelected).then(
      () => {
        setShowSuccess(true);
        setTextSuccessAlert('Categoria deletada com sucesso!');
        setTimeout(() => window.location.reload(), 1500);
      },
      () => {
        setShowError(true);
        setTextErrorAlert('Um erro ocorreu ao deletar a categoria.');
      }
    );
  };

  const total = states.categories.length;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Header loggedIn={true} />

      {/* Barra de título + busca */}
      <Box sx={{
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        flexWrap: 'wrap', gap: '12px',
        padding: '0 160px',
        marginTop: '80px',
        marginBottom: '24px',
        '@media (max-width: 1280px)': { padding: '0 80px' },
        '@media (max-width: 1024px)': { padding: '0 20px', marginTop: '70px' },
        '@media (max-width: 600px)': { padding: '0 12px', marginTop: '70px' },
      }}>
        {/* Título + badge */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <Typography variant="h1" sx={{ fontWeight: 500, fontSize: '28px', lineHeight: '40px', color: '#3E3D3D', textTransform: 'capitalize' }}>
            Categorias
          </Typography>
          {!states.loading && total > 0 && (
            <Chip
              label={total}
              size="small"
              sx={{ backgroundColor: '#006494', color: '#fff', fontWeight: 700, fontSize: '13px' }}
            />
          )}
        </Box>

        {/* Busca + botão + */}
        <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px', justifyContent: 'flex-end', '@media (max-width: 600px)': { width: '100%', justifyContent: 'stretch' } }}>
          <Box sx={{ position: 'relative', width: '340px', maxWidth: '100%' }}>
            <input
              value={search}
              onChange={e => setSearch(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && handleSearch()}
              placeholder="Buscar conteúdos, arquivos e categorias..."
              style={{
                width: '100%',
                padding: '8px 44px 8px 14px',
                background: '#fff',
                border: '1px solid rgba(0,0,0,0.18)',
                borderRadius: '8px',
                fontSize: '14px',
                color: '#3E3D3D',
                outline: 'none',
                boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
              }}
            />
            <IconButton
              onClick={handleSearch}
              sx={{ position: 'absolute', right: 0, top: '50%', transform: 'translateY(-50%)', color: '#9e9e9e' }}
            >
              <SearchOutlinedIcon />
            </IconButton>
          </Box>
          {isAdmin() && (
            <IconButton
              onClick={() => setStates(prev => ({ ...prev, showCategoryModal: true }))}
              sx={{
                color: '#fff',
                backgroundColor: '#006494',
                borderRadius: '8px',
                '&:hover': { backgroundColor: '#004f75' },
              }}
            >
              <AddIcon />
            </IconButton>
          )}
        </Box>
      </Box>

      {/* Lista de categorias */}
      <Box sx={{
        padding: '0 160px',
        flexGrow: 1,
        '@media (max-width: 1280px)': { padding: '0 80px' },
        '@media (max-width: 1024px)': { padding: '0 20px' },
        '@media (max-width: 600px)': { padding: '0 12px' },
      }}>
        {states.loading ? (
          <Loading />
        ) : (
          <CategoriesCardList categories={states.categories} setCategory={setStates} />
        )}
      </Box>

      <Footer />

      <DeleteConfirmModal
        showModal={states.showModal}
        setStates={setStates}
        deleteCard={deleteCard}
        title={states.categorySlugSelected}
      />
      <EditCategoryModal
        show={states.showEditModal}
        category={states.categorySelected}
        onHide={() => setStates(prev => ({ ...prev, showEditModal: false, categorySelected: null }))}
      />
      <NewCategoryModal
        showCategoryModal={states.showCategoryModal}
        setStates={setStates}
      />
      <AlertSuccess textAlert={textSuccessAlert} />
    </Box>
  );
};

export default Home;
